module.exports = "<p>\n  {{'ROUTE_NOT_FOUND.DESCRIPTION' | translate}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/route-not-found/route-not-found.component.html
// module id = FS9g
// module chunks = 0